// From core-plugin-api: frontend-plugin-api's AnalyticsApi type rejects MixpanelAnalyticsApi.
import { analyticsApiRef } from '@backstage/core-plugin-api';
import {
  ApiBlueprint,
  configApiRef,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import {
  ScmAuth,
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
} from '@backstage/integration-react';
import {
  githubMyPrsApiRef,
  GithubMyPrsClient,
} from '@internal/backstage-plugin-github-my-prs';
import {
  jiraMyTasksApiRef,
  JiraMyTasksClient,
} from '@internal/backstage-plugin-jira-my-tasks';
import { MixpanelAnalyticsApi } from '../../lib/analytics';

// App-level API factories moved from the legacy `apis.ts` (behaviour unchanged).
// Analytics uses a plain ApiBlueprint, not AnalyticsImplementationBlueprint. It
// replaces the app plugin's own analytics extension, so that extension's
// `implementations` input is dropped (intended: Mixpanel is the only sink).
export const appApiExtensions = [
  ApiBlueprint.make({
    name: 'analytics',
    params: defineParams =>
      defineParams({
        api: analyticsApiRef,
        deps: {},
        factory: () => new MixpanelAnalyticsApi(),
      }),
  }),
  ApiBlueprint.make({
    name: 'scm-integrations',
    params: defineParams =>
      defineParams({
        api: scmIntegrationsApiRef,
        deps: { configApi: configApiRef },
        factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
      }),
  }),
  ApiBlueprint.make({
    name: 'scm-auth',
    params: defineParams => defineParams(ScmAuth.createDefaultApiFactory()),
  }),
  // github-my-prs (PAT-425): the card is a component extension nested in
  // MyDayPage, so the app's plugin collector never discovers the plugin (it
  // only scans route-level elements). Register its API factory here instead.
  // TODO(S18): move into its plugin (NFS migration step S18).
  ApiBlueprint.make({
    name: 'plugin.github-my-prs.service',
    params: defineParams =>
      defineParams({
        api: githubMyPrsApiRef,
        deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
        factory: ({ discoveryApi, fetchApi }) =>
          new GithubMyPrsClient(discoveryApi, fetchApi),
      }),
  }),
  // jira-my-tasks (PAT-604): same reasoning as github-my-prs above, the card
  // is a component extension nested in MyDayPage, so the app's plugin
  // collector never discovers the plugin. Register its API factory here.
  // TODO(S18): move into its plugin (NFS migration step S18).
  ApiBlueprint.make({
    name: 'plugin.jira-my-tasks.service',
    params: defineParams =>
      defineParams({
        api: jiraMyTasksApiRef,
        deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
        factory: ({ discoveryApi, fetchApi }) =>
          new JiraMyTasksClient(discoveryApi, fetchApi),
      }),
  }),
];
